import React, { useState } from 'react';
 import './employeeprofile.css'; 
import HrDashboardAside from './HrDashboardAside';
// Import external CSS

function EmployeeProfile() {
  const [formData, setFormData] = useState({
    empId: '',
    empName: '',
    password: '',
    email: '',
    mobile_no: '',
    aadhar_no: '',
    pan_no: '',
    joining_date: '',
    date_of_birth: '',
    designation: '',
    address: '',
    emp_photo: null,
  });

  const [errorMsg, setErrorMsg] = useState('');
  const [formErrors, setFormErrors] = useState({
    mobile_no: '',
    aadhar_no: '',
    pan_no: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, emp_photo: e.target.files[0] });
  };
const validateForm = () => {
  let errors = {};
  let valid = true;

  // Mobile validation
  const mobileRegex = /^[6-9]\d{9}$/;
  if (!mobileRegex.test(formData.mobile_no)) {
    errors.mobile_no = 'Mobile number must be 10 digits and start with 6-9.';
    valid = false;
  }

  // Aadhar validation
  const aadharRegex = /^\d{12}$/;
  if (!aadharRegex.test(formData.aadhar_no)) {
    errors.aadhar_no = 'Aadhar number must be exactly 12 digits.';
    valid = false;
  }

  // PAN validation
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  if (!panRegex.test(formData.pan_no)) {
    errors.pan_no = 'PAN must be in format ABCDE1234F.';
    valid = false;
  }

  setFormErrors(errors);
  return valid;
};

  const handleMobileInput = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 10) {
      value = value.slice(0, 10);
    }
    setFormData({ ...formData, mobile_no: value });
  };

  const handleAadharInput = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 12) {
      value = value.slice(0, 12);
    }
    setFormData({ ...formData, aadhar_no: value });
  };
const handlePanInput = (e) => {
  let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (value.length > 10) value = value.slice(0, 10);
  setFormData({ ...formData, pan_no: value });
};


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      setErrorMsg('Please correct the errors above.');
      return;
    }

    const form = new FormData();
    for (const key in formData) {
      form.append(key, formData[key]);
    }

    fetch('https://cleezoclass.com:8443/api/employee', {
      method: 'POST',
      body: form,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          setErrorMsg(data.message);
        } else {
          setErrorMsg('Form submitted successfully!');
        }
      })
      .catch((error) => {
        setErrorMsg('Error submitting form: ' + error);
      });
  };

  return (
  
    <div className="emp-form-container mainBlock">
      <HrDashboardAside />
    <h1 className="emp-header">Employee Profile</h1>
    <div className="emp-form-background">
      <form onSubmit={handleSubmit} encType="multipart/form-data" className="emp-form">
        {/* Row 1: Employee ID, Employee Name, Password */}
        <div className="emp-form-group">
          <label htmlFor="empId">Employee ID</label>
          <input
            type="text"
            id="empId"
            name="empId"
            placeholder="Enter Employee ID"
            value={formData.empId}
            onChange={handleChange}
          />
        </div>
        <div className="emp-form-group">
          <label htmlFor="empName">Employee Name</label>
          <input
            type="text"
            id="empName"
            name="empName"
            placeholder="Enter Employee Name"
            value={formData.empName}
            onChange={handleChange}
          />
        </div>
        <div className="emp-form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            name="password"
            placeholder="Enter Password"
            value={formData.password}
            onChange={handleChange}
          />
        </div>
  
        {/* Row 2: Email, Mobile Number, Aadhar Number */}
        <div className="emp-form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Enter Email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="emp-form-group">
          <label htmlFor="mobile_no">Mobile Number</label>
          <input
            type="text"
            id="mobile_no"
            name="mobile_no"
            placeholder="Enter Mobile Number"
            value={formData.mobile_no}
  onChange={handleMobileInput}
          />
          {formErrors.mobile_no && <span className="emp-error">{formErrors.mobile_no}</span>}
        </div>
        <div className="emp-form-group">
          <label htmlFor="aadhar_no">Aadhar Number</label>
          <input
            type="text"
            id="aadhar_no"
            name="aadhar_no"
            placeholder="Enter Aadhar Number"
            value={formData.aadhar_no}
  onChange={handleAadharInput}
          />
          {formErrors.aadhar_no && <span className="emp-error">{formErrors.aadhar_no}</span>}
        </div>
  
        {/* Row 3: PAN, Joining Date, Date of Birth */}
        <div className="emp-form-group">
          <label htmlFor="pan_no">PAN Card</label>
          <input
            type="text"
            id="pan_no"
            name="pan_no"
            placeholder="Enter PAN Card Number"
            value={formData.pan_no}
            onChange={handlePanInput}
          />
          {formErrors.pan_no && <span className="emp-error">{formErrors.pan_no}</span>}
        </div>
        <div className="emp-form-group">
          <label htmlFor="joining_date">Joining Date</label>
          <input
            type="date"
            id="joining_date"
            name="joining_date"
            value={formData.joining_date}
            onChange={handleChange}
          />
        </div>
        <div className="emp-form-group">
          <label htmlFor="date_of_birth">Date of Birth</label>
          <input
            type="date"
            id="date_of_birth"
            name="date_of_birth"
            value={formData.date_of_birth}
            onChange={handleChange}
          />
        </div>
  
        {/* Row 4: Designation, Address, Employee Photo */}
        <div className="emp-form-group">
          <label htmlFor="designation">Designation</label>
          <select
            id="designation"
            name="designation"
            value={formData.designation}
            onChange={handleChange}
          >
            <option value="">Select Designation</option>
            <option value="Employee">Employee</option>
            <option value="HR">HR</option>
            <option value="Project Manager">Project Manager</option>
            <option value="Admin">Admin</option>
            <option value="Chief">Chief</option>
            <option value="Full Stack Developer -trainee">Full Stack Developer -trainee</option>
            <option value="Marketing Executive">Marketing Executive</option>
          </select>
        </div>
        <div className="emp-form-group">
          <label htmlFor="address">Address</label>
          <textarea
            id="address"
            name="address"
            placeholder="Enter Address"
            value={formData.address}
            onChange={handleChange}
          ></textarea>
        </div>
        <div className="emp-form-group">
          <label htmlFor="emp_photo">Employee Photo</label>
          <input
            type="file"
            id="emp_photo"
            name="emp_photo"
            accept="image/*"
            onChange={handleFileChange}
          />
        </div>
  
        <button type="submit" className="emp-submit-btn">Submit</button>
        <p id="error-msg" className="emp-error-msg">{errorMsg}</p>
      </form>
    </div>
  </div>
  
  );
}

export default EmployeeProfile;
